import { useLocale } from "next-intl";
import { Locales } from "i18n/country";
import { useFeatureFlag } from "contexts/FeatureFlagsContext";
import { FeatureFlagNames } from "domain/FeatureFlags/featureFlags.types";

/**
 * Mirrors the backend's NoRecordsReportPolicy: a report can be purchased even when the record
 * check returns no records, but only for DE and only when the proceed-with-no-records toggle is on.
 * When true, the "X records found" headline should be replaced with the report-available text.
 */
export const useNoRecordsReportAvailable = (totalRecords: number): boolean => {
  const locale = useLocale();
  const { isEnabled } = useFeatureFlag(FeatureFlagNames.PROCEED_WITH_NO_RECORDS);

  return isEnabled && locale === Locales.GERMAN && totalRecords === 0;
};
